/* eslint-disable */
import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  Inject,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { forkJoin, lastValueFrom, Observable, Subject } from "rxjs";
import { OperatorFunction } from "rxjs";
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
  switchMap,
} from "rxjs/operators";
import { GetBCForSalesOrderDto } from "../../../../core/models/orders/getBCForSalesOrderDto";
import { GetBacForSalesOrderDto } from "../../../../core/models/orders/getBacForSalesOrderDto";
import { CustomerGroup } from "../../../../core/models/client/addclient/customerGroupList";
import { Source } from "../../../../core/models/client/addclient/sourceList";
import { AddressCountryRegion } from "../../../../core/models/client/addclient/countryRegionList";
import { District } from "../../../../core/models/client/addclient/districtList";
import { AddressCounty } from "../../../../core/models/client/addclient/countyList";
import { AddressState } from "../../../../core/models/client/addclient/stateList";
import { Currency } from "../../../../core/models/client/addclient/currencyList";
import { Client } from "../../../../core/models/client/details/client";
import { City } from "../../../../core/models/client/addclient/cityList";
import { Zip } from "../../../../core/models/client/addclient/zipList";
import { TypeList } from "../../../../core/models/client/addclient/typeList";
import { ClientDto } from "../../../../core/models/client/details/clientDto";
import { AttachmentUrl } from "../../../../core/models/client/details/attachmentUrl";
import { VerifyClientFilter } from "../../../../core/models/client/verifyClientFilter";
import { AddProgramDto } from "../../../../core/models/program/addProgramDto";
import { DropDownDto } from "../../../../core/models/program/dropdownDto";
import { Router } from "@angular/router";
import { LoaderService } from "../../../../core/services/loader.service";
import { SaleOrderService } from "../../../../core/services/sale-order.service";
import { ProgramsService } from "../../../../core/services/programs.service";
import { MsalApiService } from "../../../../core/services/msal-api.service";
import { UserManagementService } from "../../../../core/services/user-management.service";
import { ValidateLogin } from "../../../../core/models/validate-login.dto";
import { getBase64 } from "../../../../core/services/shared.service";
import { FileName } from "../../../../shared/enums/fileName";
import { FileType } from "../../../../shared/enums/fileType";
import { ClientInformation } from "../../../../core/models/client/details/clientInformation";
import { InvoiceInformation } from "../../../../core/models/client/details/invoiceInformation";
import { PayableInformation } from "../../../../core/models/client/details/payableInformation";
import { ClientPurpose } from "../../../../shared/enums/clientPurpose";
import { EnumContactType } from "../../../../shared/enums/enumContactType";
import { ClientPurposeType } from "../../../../shared/enums/clientpurposetype";
import { GetProgramDetailsEmailDto } from "../../../../core/models/client/addclient/getProgramDetailsForEmailDto";
import { ProgramListDto } from "../../../../core/models/program/programListDto";
import * as MicrosoftGraph from "@microsoft/microsoft-graph-types";
import { AddNewProspectService } from "../../../../core/services/add-new-prospect.service";
import { CommonModule } from "@angular/common";
import { TableModule } from "primeng/table";
import { AddressComponent } from "../../../../shared/components/address/address.component";
import { ScrollerModule } from "primeng/scroller";
import { CreateProspectDto } from "../../../../core/models/prospect/addProspect/prospect";
import {
  VendorDto,
  MelissaAddress,
  ClientEvent,
  FileEvent,
  AddressValidation,
} from "../../../../core/models/client/vendor.interface";
import { ProgramClientListDto } from "../../../../core/models/program/programClientListDto";
import { AutoCompleteModule } from "primeng/autocomplete";
import { Popover, PopoverModule } from "primeng/popover";
import { SelectModule } from "primeng/select";
import { ProfileFormService } from "../../../../core/services/profile-form.service";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { InputTextModule } from "primeng/inputtext";
import { ButtonModule } from "primeng/button";
import { RadioButtonModule } from "primeng/radiobutton";
import { DropdownModule } from "primeng/dropdown";
import { ToggleSwitchModule } from "primeng/toggleswitch";
import { AddNewClientService } from "../../../../core/services/add-new-client.service";
import { GenericResponseDto } from "../../../../core/models/generic-response.dto";
import { GetUserDto } from "../../../../core/models/users/users/getUserDto";
import { ClientSearchList } from "../../../../core/models/shared/clientSearchList";
import { Contact } from "../../../../core/models/shared/contact";
import { FileUploadDto } from "../../../../core/models/shared/fileUploadDto";
import { ProspectsDetailService } from "../../../../core/services/prospect-detail.service";
import { SamplepoListingService } from "../../../../core/services/sample-po.service";
import { ProgramComponent } from "../program/program.component";
import { AddProgramBladeComponent } from "../add-program-blade/add-program-blade.component";
import { ClientAttachment } from "../../../../core/models/client/details/clientAttachment";
import { ClientDetailDto } from "../../../../core/models/client/details/clientDetailDto";
import { CardModule } from "primeng/card";
import {
  GlobalFileDragDropDirective,
  DroppedFile,
} from "../../../../shared/directives/global-file-drag-drop.directive";
import { GlobalFileUploadService } from "../../../../shared/services/global-file-upload.service";

@UntilDestroy()
@Component({
  selector: "jni-add-new-client",
  templateUrl: "./add-new-client.component.html",
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ProgramComponent,
    SelectModule,
    TableModule,
    AddressComponent,
    ScrollerModule,
    AutoCompleteModule,
    PopoverModule,
    InputTextModule,
    ButtonModule,
    DropdownModule,
    RadioButtonModule,
    ToggleSwitchModule,
    AddressComponent,
    AddProgramBladeComponent,
    CardModule,
    FormsModule,
    GlobalFileDragDropDirective,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  styleUrls: [
    "./add-new-client.component.scss",
    "../../../../shared/directives/global-file-drag-drop.styles.scss",
  ],
})
export class AddNewClientComponent implements OnInit {
  clientForm: FormGroup;
  showLoader = false;
  typeList: TypeList[] = [];
  bcList: GetBCForSalesOrderDto[] = [];
  bacList: GetBacForSalesOrderDto[] = [];
  sourceList: Source[] = [];
  customerGroupList: CustomerGroup[] = [];
  parentCompanyNameList: Client[] = [];
  currencyList: Currency[] = [];
  countryRegionList: AddressCountryRegion[] = [];
  zipList: Zip[] = [];
  districtList: District[] = [];
  cityList: City[] = [];
  countyList: AddressCounty[] = [];
  stateList: AddressState[] = [];
  userId = "";
  bcUserDefaultSelectionId = "";
  bacUserDefaultSelectionId?: string = "";
  isCountrySelected = false;
  taxExemptionFileName = "";
  taxExemptionValidationMessage = false;
  taxExemptionRemove = false;
  taxExemptionFileSize = false;
  parentCompanyPartyNumber = "";

  resaleCertificateFileName = "";
  resaleCertificateValidationMessage = false;
  resaleCertificateRemove = false;
  resaleCertificateFileSize = false;

  quoteId = "";
  countryRegionSelectedId = "";
  stateSelectedId = "";
  zipSelectionCode = "";
  customerAccount = "Fetching...";
  showSmallLoader = false;
  clientObj!: ClientDto;
  fileAttachment: ClientAttachment[] = [];
  addressValidationStatus = true;
  files?: AttachmentUrl;
  fileObject: FileUploadDto[] = [];
  resaleFileUrl?: GenericResponseDto<string>;
  taxexemptionFileUrl?: GenericResponseDto<string>;
  isAddressValidationButton = true;
  getObjectFromVerifyClient = {} as VerifyClientFilter;
  isPrimaryOne = "1";
  isPrimaryZero = "0";
  isResaleToggleStatus = true;
  isTaxExemptionToggleStatus = true;
  customerAccountNumberStatus = true;
  getZipCode: string[] = [];
  getFilteredZipCode: string[] = [];
  fileSizeInKb = 1024;
  parentCompanyName: { id: number; nameAliasD365: string } = {
    id: 0,
    nameAliasD365: "",
  };
  addClientObj!: CreateProspectDto;
  updateClientObj!: CreateProspectDto;
  showZip = true;
  showDistrict = true;
  showPostBox = true;
  showCity = true;
  showCounty = true;
  showState = true;
  showStreetNumber = true;
  showStreet = true;
  showbuildingComplement = true;
  showAppartment = true;
  parentCompanyNameValid = false;
  clientLists: ClientSearchList[] = [];
  userPersonnelNumber!: string;
  programName = "";
  programStatus = false;
  displayAddProgram = false;
  result$!: Observable<{
    facilitatorList: DropDownDto[];
    threePLList: DropDownDto[];
    platformList: DropDownDto[];
  }>;
  programData = {} as AddProgramDto;
  threePLList: DropDownDto[] = [];
  platformList: DropDownDto[] = [];
  facilitatorList: DropDownDto[] = [];
  nadelOwnInvCheckedYes = false;
  nadelOwnInvCheckedNo = false;
  uses3PLCheckedYes = false;
  uses3PLCheckedNo = false;
  userInfo: GetUserDto = {} as GetUserDto;
  isRadioButtonDisabled = false;
  clientSaveAfterProgramAdd = false;

  public text$ = new Subject<string>();
  public searchClient$ = new Subject<string>();

  @ViewChild("addprogram", { static: false })
  addprogram!: AddProgramBladeComponent;

  constructor(
    private _formBuilder: FormBuilder,
    private _toastr: JniToastrService,
    private route: Router,
    private _addNewClientService: AddNewClientService,
    private _loaderService: LoaderService,
    private _addNewProspectService: AddNewProspectService,
    private _saleOrderService: SaleOrderService,
    private _profileFormService: ProfileFormService,
    private _loginService: UserManagementService,
    private _programService: ProgramsService,
    private _msalApisService: MsalApiService,
    private _prospectDetails: ProspectsDetailService,
    private _samplepoListingService: SamplepoListingService,
    private _globalFileUploadService: GlobalFileUploadService
  ) {
    this.clientForm = this._formBuilder.group({
      id: 0,
      basicInformation: this._formBuilder.group({
        customerAccountD365: [""],
        nameAliasD365: [
          "",
          [
            Validators.required,
            Validators.minLength(2),
            Validators.maxLength(300),
          ],
        ],
        knownAsD365: ["", [Validators.minLength(2), Validators.maxLength(200)]],
        partyTypeD365: ["", Validators.required],
        brandingConsultantD365: [""],
        brandingAccountCordinator: [""],
        source: ["", [Validators.required]],
        customerGroupIdD365: ["", [Validators.required]],
        rsmJNIParentCompanyNameD365: [""],
        dUNSNoD365: ["", [Validators.minLength(1), Validators.maxLength(10)]],
        salesCurrencyCodeD365: [""],
        companyUrl: [
          "",
          [
            Validators.required,
            Validators.minLength(2),
            Validators.maxLength(500),
          ],
        ],
        isRequestCreditCheck: [false],
        customerPORequired: [false],
        isResale: [false],
        isTaxExemption: [false],
        notes: [""],
        bCPersonnelNumberD365: [""],
        parentCompanyPartyNumberD365: [""],
        programId: [0],
        uses3PLWarehouse: [null, Validators.required], // For "Uses 3rd Party Warehouse"
        nadelOwnedInventory: [null, Validators.required], // For "Nadel Owned Inventory"
      }),
      addressInformation: this._formBuilder.group({
        countryRegionIdD365: ["", [Validators.required]],
        zipCodeD365: [""],
        districtNameD365: [""],
        postBoxD365: [""],
        cityD365: [""],
        countyD365: [""],
        streetNumberD365: [""],
        stateD365: [""],
        addressD365: [""],
        streetD365: [""],
        notes: [""],
        purposeD365: ClientPurpose.Business,
        isPrimaryD365: "Yes",
        addressLocationNameD365: [""],
        buildingComplimentD365: [""],
        apartment_RUD365: [""],
        addressFormat: [""],
        validateAddress: [""],
        melissaAddressKeyD365: [""],
        addressLine1: [""],
        addressLine2: [""],
        addressLine3: [""],
        billingAttention: ["", [Validators.maxLength(30)]],
        billingLocation: ["", [Validators.maxLength(30)]],
      }),
      clientInformation: this._formBuilder.group({
        clientContactSerialNumber: 0,
        clientFirstNameD365: [
          "",
          [Validators.pattern("^[a-zA-Z0-9 ]+|[\u10D0-\u10F0]+$")],
        ],
        clientLastNameD365: [
          "",
          [Validators.pattern("^[a-zA-Z0-9 ]+|[\u10D0-\u10F0]+$")],
        ],
        clientPhoneNumberD365: [""],
        clientEmailAddressD365: [
          "",
          [
            Validators.pattern(
              `^[a-zA-Z0-9._%+-]+(?:'[a-zA-Z0-9._%+-]+)?@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$`
            ),
          ],
        ],
        clientTitle: [
          "",
          [Validators.pattern("^[a-zA-Z0-9 ]+|[\u10D0-\u10F0]+$")],
        ],
      }),
      invoiceInformation: this._formBuilder.group({
        invoiceContactSerialNumber: 0,
        invoiceFirstNameD365: [
          "",
          [Validators.pattern("^[a-zA-Z0-9 ]+|[\u10D0-\u10F0]+$")],
        ],
        invoiceLastNameD365: [
          "",
          [Validators.pattern("^[a-zA-Z0-9 ]+|[\u10D0-\u10F0]+$")],
        ],
        invoicePhoneNumberD365: [""],
        invoiceEmailAddressD365: [
          "",
          [
            Validators.required,
            Validators.pattern(
              `^[a-zA-Z0-9._%+-]+(?:'[a-zA-Z0-9._%+-]+)?@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$`
            ),
          ],
        ],
        invoiceTitle: [""],
      }),
      payableInformation: this._formBuilder.group({
        payableContactSerialNumber: 0,
        payableFirstNameD365: [
          "",
          [Validators.pattern("^[a-zA-Z0-9 ]+|[\u10D0-\u10F0]+$")],
        ],
        payableLastNameD365: [
          "",
          [Validators.pattern("^[a-zA-Z0-9 ]+|[\u10D0-\u10F0]+$")],
        ],
        payablePhoneNumberD365: [""],
        payableEmailAddressD365: [
          "",
          [
            Validators.pattern(
              `^[a-zA-Z0-9._%+-]+(?:'[a-zA-Z0-9._%+-]+)?@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$`
            ),
          ],
        ],
        payableTitle: [""],
      }),
    });
    this.getObjectFromVerifyClient = this.route.getCurrentNavigation()?.extras
      .state as VerifyClientFilter;

    if (this.getObjectFromVerifyClient == undefined) {
      const url = "/clients/active/verify-client";
      this.route.navigate([url]);
    }
  }

  formErrors: Record<string, string> = {
    nameAliasD365: "",
    partyTypeD365: "",
    customerGroupIdD365: "",
    countryRegionIdD365: "",
    clientFirstNameD365: "",
    clientLastNameD365: "",
    clientPhoneNumberD365: "",
    clientEmailAddressD365: "",
    clientTitle: "",
    invoiceFirstNameD365: "",
    invoiceLastNameD365: "",
    invoicePhoneNumberD365: "",
    invoiceEmailAddressD365: "",
    payableFirstNameD365: "",
    payableLastNameD365: "",
    payablePhoneNumberD365: "",
    payableEmailAddressD365: "",
    knownAsD365: "",
    dUNSNoD365: "",
    billingLocation: "",
    billingAttention: "",
    companyUrl: "",
    source: "",
  };

  validationMessages: Record<string, Record<string, string>> = {
    nameAliasD365: {
      required: "Client name is required.",
      minlength: "Client name must be greater than 2 characters.",
      maxlength: "Client name must be less than 300 characters.",
    },
    customerGroupIdD365: {
      required: "Client group is required.",
    },
    countryRegionIdD365: {
      required: "Country is required.",
    },
    clientFirstNameD365: {
      pattern: "First name format is not correct.",
    },
    clientLastNameD365: {
      pattern: "Last name format is not correct.",
    },
    clientPhoneNumberD365: {
      pattern: "Phone number must contain 11 digits",
    },
    clientEmailAddressD365: {
      pattern: "Email format is not correct.",
    },
    clientTitle: {
      pattern: "Title format is not correct.",
    },
    invoiceFirstNameD365: {
      pattern: "First name format is not correct.",
    },
    invoiceLastNameD365: {
      pattern: "Last name format is not correct.",
    },
    invoicePhoneNumberD365: {
      pattern: "Phone number must contain 11 digits.",
    },
    invoiceEmailAddressD365: {
      required: "Email is required.",
      pattern: "Email format is not correct.",
    },
    payableFirstNameD365: {
      pattern: "First name format is not correct.",
    },
    payableLastNameD365: {
      pattern: "Last name format is not correct.",
    },
    payablePhoneNumberD365: {
      pattern: "Phone number must contain 11 digits",
    },
    payableEmailAddressD365: {
      pattern: "Email format is not correct.",
    },
    partyTypeD365: {
      required: "Type is required",
    },
    knownAsD365: {
      minlength: "known as must be greater than 2 characters.",
      maxlength: "known as must be less than 200 characters.",
    },
    dUNSNoD365: {
      minlength: "Duns# must be greater than 1 characters.",
      maxlength: "Duns# must be less than 10 characters.",
    },
    companyUrl: {
      required: "Company url is required.",
      minlength: "Company url must be greater than 2 characters.",
      maxlength: "Company url must be less than 500 characters.",
    },
    billingLocation: {
      maxlength: "Location must be less than 30 characters.",
    },
    billingAttention: {
      maxlength: "Attention must be less than 30 characters.",
    },
    source: {
      required: "Client Origin is required.",
    },
  };

  ngOnInit(): void {
    if (this.getObjectFromVerifyClient?.id == 0) {
      this.getCustomerAccountNumber();
    } else {
      this.getProspectByIdData(this.getObjectFromVerifyClient?.id?.toString());

      if (this.getObjectFromVerifyClient?.quoteId) {
        this.quoteId = this.getObjectFromVerifyClient.quoteId;
      }
    }
    this.getUserProfile();
    this.getTypeListData();
    this.getSourceListData();
    this.getCustomerGroupListData();
    this.getCurrencyListData();
    this.getParentCompanyNameListData();
    this.getCountryRegionListData();
    this.patchValueFromVerifyClient();
    this.searchClientName();
    //this.getBCListData();
    this.getWhoISupport();
    this.getAllProgramDropdownValues();
    this.clientForm.valueChanges.subscribe(data => {
      this.logValidationErrors(this.clientForm);
      this.addressValidation(data);
    });
    this.getUserProfile();
    this.clientForm.get(["basicInformation", "customerAccountD365"])?.disable();
    this.clientForm.get(["basicInformation", "nameAliasD365"])?.disable();
  }

  selectedZipCode(zipCode: string) {
    if (!zipCode) {
      return;
    }
    this._addNewClientService.getPostalCodeByZipCode(zipCode).subscribe(res => {
      this.showSmallLoader = true;
      if (!res.data) {
        this.showSmallLoader = false;
        return;
      }
      this._addNewClientService
        .getCityList(res.data.stateId, res.data.countryRegionId)
        .pipe(
          map((cityResponse: GenericResponseDto<City[]>) => {
            this.cityList = cityResponse.data;

            return cityResponse.data.filter(
              (city: City) =>
                city.cityKeyD365?.includes(res?.data?.cityId) &&
                city.countryRegionIdD365 == res?.data?.countryRegionId &&
                city.countyIdD365 == res?.data?.countyId &&
                city.stateIdD365 == res?.data?.stateId
            );
          })
        )
        .pipe(untilDestroyed(this))
        .subscribe({
          next: response => {
            this.clientForm.patchValue({
              addressInformation: {
                countyD365: response[0]?.countyIdD365,
                cityD365: response[0]?.nameD365,
                stateD365: response[0]?.stateIdD365,
                streetD365: res?.data?.street,
              },
            });
            this.showSmallLoader = false;
          },
          error: () => {
            this.showSmallLoader = false;
          },
        });
    });
  }

  searchZipCode: OperatorFunction<string, readonly string[]> = (
    text$: Observable<string>
  ) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      switchMap(async (term: string) =>
        term.length < 4
          ? []
          : (this.getFilteredZipCode = await this.getZipListData(
              this.countryRegionSelectedId,
              term
            ))
      )
    );

  async zipCodeSearchFilter(event: { value: string }) {
    this.selectedZipCode(event.value);
  }

  // formatterParentInput = (state: any) => state.nameAliasD365;
  // formatterParent = (state: any) => state.nameAliasD365;
  malisaFormatter = (result: MelissaAddress): string =>
    result?.Address?.Address ?? "";

  searchParentCompanyName: OperatorFunction<string, readonly Client[]> = (
    text$: Observable<string>
  ) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      filter(term => term.length >= 3),
      map(term =>
        this.parentCompanyNameList.filter(state =>
          new RegExp(term, "mi").test(state.nameAliasD365)
        )
      )
    );
  selectedStreet({ item }: { item: MelissaAddress }) {
    if (!item.Address.PostalCode) {
      return;
    }

    this.clientForm.patchValue({
      addressInformation: {
        cityD365: item.Address.Locality,
        stateD365: item.Address.AdministrativeArea,
        streetD365: item.Address.DeliveryAddress,
        zipCodeD365: item.Address.PostalCodePrimary,
        districtNameD365: item.Address.SubAdministrativeArea,
        postBoxD365: item.Address.PostBox,
        countyD365: item.Address.SubAdministrativeArea,
        streetNumberD365: item.Address.Address1,
        buildingComplimentD365: item.Address.Building,
      },
    });
    this._addNewClientService
      .getPostalCodeByZipCode(item.Address.PostalCodePrimary)
      .subscribe(res => {
        this.showSmallLoader = true;
        if (!res.data) {
          this.showSmallLoader = false;
          return;
        }
        this._addNewClientService
          .getCityList(res.data.stateId, res.data.countryRegionId)
          .pipe(
            map((cityResponse: GenericResponseDto<City[]>) => {
              this.cityList = cityResponse.data;

              return cityResponse.data.filter(
                (city: City) =>
                  city.cityKeyD365?.includes(res?.data?.cityId) &&
                  city.countryRegionIdD365 == res?.data?.countryRegionId &&
                  city.countyIdD365 == res?.data?.countyId &&
                  city.stateIdD365 == res?.data?.stateId
              );
            })
          )
          .pipe(untilDestroyed(this))
          .subscribe({
            next: () => {
              this.showSmallLoader = false;
            },
            error: () => {
              this.showSmallLoader = false;
            },
          });
      });
  }

  async getZipListData(id: string, name: string) {
    this.getFilteredZipCode = [];
    this.showSmallLoader = true;
    const res = await lastValueFrom(
      this._addNewClientService.getZipList(id, name).pipe(untilDestroyed(this))
    );
    this.getZipCode = res.data;
    this.showSmallLoader = false;
    return this.getZipCode;
  }

  onResaleEnabled(event: Event) {
    if (event.target instanceof HTMLInputElement && event.target.checked) {
      this.isResaleToggleStatus = false;
      if (this.resaleCertificateFileName == "") {
        this.resaleCertificateValidationMessage = true;
      }
    } else {
      this.isResaleToggleStatus = true;
      this.resaleCertificateValidationMessage = false;
    }
  }

  selectParentCompanyName(event: { item: { partyNumber: string } }) {
    this.parentCompanyPartyNumber = event.item.partyNumber;
  }

  onTaxExemptionEnabled(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.checked) {
      this.isTaxExemptionToggleStatus = false;
      if (this.taxExemptionFileName == "") {
        this.taxExemptionValidationMessage = true;
      }
    } else {
      this.isTaxExemptionToggleStatus = true;
      this.taxExemptionValidationMessage = false;
    }
  }

  patchValueFromVerifyClient() {
    if (this.getObjectFromVerifyClient != undefined) {
      this.clientForm.patchValue({
        basicInformation: {
          nameAliasD365: this.getObjectFromVerifyClient.clientName,
          dUNSNoD365: this.getObjectFromVerifyClient.dUNS,
          companyUrl: this.getObjectFromVerifyClient.companyUrl,
        },
        addressInformation: {
          streetD365: this.getObjectFromVerifyClient.streetAddress,
        },
      });
      this.countryRegionSelectedId = this.getObjectFromVerifyClient.country;
      this.onCountryRegionSelection(this.countryRegionSelectedId);
      this.zipSelectionCode = this.getObjectFromVerifyClient.zip;
      if (this.zipSelectionCode && this.countryRegionSelectedId) {
        this.selectedZipCode(this.zipSelectionCode);
      }
    }
  }

  logValidationErrors(group: FormGroup = this.clientForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = "";
        if (
          abstractControl &&
          !abstractControl.valid &&
          (abstractControl.touched || abstractControl.dirty)
        ) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey && messages) {
              this.formErrors[key] += messages[errorKey] + " ";
            }
          }
        }
      }
    });
  }

  searchMelissa: OperatorFunction<string, readonly MelissaAddress[]> = (
    text$: Observable<string>
  ) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      switchMap(async term =>
        term === ""
          ? []
          : await this._addNewClientService.getMelissaData(
              term,
              this.countryRegionSelectedId
            )
      )
    );

  addressValidation(data: AddressValidation): void {
    const addressObj = data.addressInformation;
    if (
      addressObj.countryRegionIdD365 != "" &&
      addressObj.countryRegionIdD365 != null &&
      addressObj.cityD365 != "" &&
      addressObj.cityD365 != null &&
      addressObj.stateD365 != "" &&
      addressObj.stateD365 != null
    ) {
      this.isAddressValidationButton = false;
    } else {
      this.isAddressValidationButton = true;
    }
  }

  getCustomerAccountNumber() {
    this._addNewClientService
      .getCustomerAccount()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.customerAccount =
            res.data != undefined ? res.data?.accountNumber : "";
          if (
            this.customerAccount != "Fetching..." &&
            this.customerAccount != ""
          ) {
            this.clientForm.patchValue({
              basicInformation: {
                customerAccountD365: this.customerAccount,
              },
            });

            this.customerAccountNumberStatus = false;
          }
        },
      });
  }

  getTypeListData() {
    this._addNewClientService
      .getTypeList()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res?.data) {
            this.typeList = res.data.filter(
              x => !x.typeDescription?.toLowerCase()?.includes("person")
            );
          }
        },
      });
  }

  getWhoISupport() {
    this._samplepoListingService
      .getAllWhoISupport()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (res: GenericResponseDto<GetBCForSalesOrderDto[]>) => {
          if (res.data != null) {
            this.bcList = res.data;
            this.bcList = this.bcList.map(item => ({
              ...item,
              personalNumberProjectName: `${item.personnelNumber} : ${item.projectName}`,
            }));

            if (this.getObjectFromVerifyClient) {
              if (
                this.getObjectFromVerifyClient.brandingConsultant !== "" &&
                this.bcList != null
              ) {
                const bcUserObj = this.bcList.filter(
                  x =>
                    x.projectName ==
                    this.getObjectFromVerifyClient?.brandingConsultant
                );
                if (bcUserObj.length > 0) {
                  this.bcUserDefaultSelectionId = bcUserObj[0].personnelNumber;
                  this.getBacForSalesOrder(bcUserObj[0].personnelNumber);
                }
              } else {
                this.removeZeroValueFromBrandingConsultant();
              }
            }
            this.patchValueInBcAndBacAfterProspectConvert();
          }
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  getBacForSalesOrder(personnelNumber: string) {
    this._saleOrderService
      .getBacForSalesOrder(personnelNumber)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data != null) {
            this.bacList = res.data;
            this.bacList = this.bacList.map(item => ({
              ...item,
              personalNumberProjectName: `${item.personnelNumber} : ${item.name}`,
            }));

            const filterBacObject = res.data.filter(
              x => x.personnelNumber === this.userPersonnelNumber
            );

            if (filterBacObject.length > 0) {
              this.bacUserDefaultSelectionId =
                filterBacObject[0].personnelNumber;
            } else {
              if (this.bacList.length > 0) {
                this.bacUserDefaultSelectionId =
                  this.bacList[0].personnelNumber;
              } else {
                this.bacUserDefaultSelectionId = "";
              }
            }
          }
        },
      });
  }

  getBacForSalesOrderForProspect(personnelNumber: string) {
    this._saleOrderService
      .getBacForSalesOrder(personnelNumber)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data != null) {
            this.bacList = res.data;
          }
        },
      });
  }

  getUserProfile() {
    this._loginService
      .validateLogin()
      .pipe()
      .subscribe((res: GenericResponseDto<ValidateLogin>) => {
        this.getUserById(res?.data?.userId);
      });
  }

  getUserById(userId: number) {
    this._profileFormService.getUsersById(userId).subscribe({
      next: async res => {
        if (res.data != null) {
          this.userPersonnelNumber = res.data.personnelNumber;
          if (
            this.userPersonnelNumber &&
            this.bcList &&
            !this.prospectObject &&
            !this.getObjectFromVerifyClient?.brandingConsultant
          ) {
            const filterBacObject = this.bcList?.filter(
              x => x.personnelNumber === this.userPersonnelNumber
            );
            if (filterBacObject.length > 0) {
              this.bcUserDefaultSelectionId =
                filterBacObject[0].personnelNumber;
              this.getBacForSalesOrder(filterBacObject[0].personnelNumber);
            }
          } else {
            this.defaultBrandingConsultant();
          }
        }
      },
    });
  }

  defaultBrandingConsultant() {
    if (
      this.bcList != null &&
      !this.userPersonnelNumber &&
      !this.getObjectFromVerifyClient?.brandingConsultant
    ) {
      this.bcUserDefaultSelectionId = this.bcList[0]?.personnelNumber;
      this.getBacForSalesOrder(this.bcList[0]?.personnelNumber);
    }
  }

  removeZeroValueFromBrandingConsultant() {
    this.clientForm.patchValue({
      basicInformation: {
        brandingConsultantD365: "",
      },
    });
  }

  onBcUserChangeSelection(id: string) {
    if (id) {
      this.getBacForSalesOrder(id);
    }
    const personalNumber = id || "";
    this.addprogram.patchValuesInProgramBcfield(personalNumber);
  }

  getSourceListData() {
    this._addNewClientService
      .getSourceList()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.sourceList = res?.data;
        },
      });
  }

  getCustomerGroupListData() {
    this._addNewClientService
      .getCustomerGroupList()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.customerGroupList = res?.data?.filter(
            x => x.customerGroupIdD365 !== "Default"
          );
        },
      });
  }

  getParentCompanyNameListData() {
    this._addNewClientService
      .getParentCompanyNameList()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.parentCompanyNameList = res.data;
        },
      });
  }

  getCurrencyListData() {
    this._addNewClientService
      .getCurrencyList()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.currencyList = res.data;
        },
      });
  }

  getCountryRegionListData() {
    this._addNewClientService
      .getCountryRegionList()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.countryRegionList = res?.data;
        },
      });
  }

  // getDistrictListData() {
  //   this.showSmallLoader = true;
  //   this._addNewClientService
  //     .getDistrictList()
  //     .pipe(untilDestroyed(this))
  //     .subscribe({
  //       next: res => {
  //         this.districtList = res.data;
  //         this.showSmallLoader = false;
  //       },
  //       error: () => {
  //         this.showSmallLoader = false;
  //       },
  //     });
  // }

  getCityListData(stateid: string, countryid: string) {
    this.showSmallLoader = true;
    this._addNewClientService
      .getCityList(stateid, countryid)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.cityList = res?.data;
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  getCountyListData(id: string) {
    this.showSmallLoader = true;
    this._addNewClientService
      .getCountyList(id)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.countyList = res?.data;
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  filterAddressesUsingAddressFormats(description: string | null) {
    if (
      !description?.toLowerCase().includes("zip") &&
      !description?.toLowerCase().includes("postal_code") &&
      !description?.toLowerCase().includes("postcode") &&
      !description?.toLowerCase().includes("postal code")
    ) {
      this.showZip = false;
    } else {
      this.showZip = true;
    }
    if (!description?.toLowerCase().includes("district")) {
      this.showDistrict = false;
    } else {
      this.showDistrict = true;
    }
    if (!description?.toLowerCase().includes("city")) {
      this.showCity = false;
    } else {
      this.showCity = true;
    }
    if (!description?.toLowerCase().includes("county")) {
      this.showCounty = false;
    } else {
      this.showCounty = true;
    }
    if (
      !description?.toLowerCase().includes("state") &&
      !description?.toLowerCase().includes("province")
    ) {
      this.showState = false;
    } else {
      this.showState = true;
    }
    if (!description?.toLowerCase().includes("street")) {
      this.showStreet = false;
    } else {
      this.showStreet = true;
    }
    if (!description?.toLowerCase().includes("number")) {
      this.showStreetNumber = false;
    } else {
      this.showStreetNumber = true;
    }
    if (
      !description?.toLowerCase().includes("complement") &&
      !description?.toLowerCase().includes("building")
    ) {
      this.showbuildingComplement = false;
    } else {
      this.showbuildingComplement = true;
    }
    if (!description?.toLowerCase().includes("apartment")) {
      this.showAppartment = false;
    } else {
      this.showAppartment = true;
    }
    const poBox = description
      ?.toLowerCase()
      .split(",")
      .join(" ")
      .split("/")
      .join(" ")
      .split("_")
      .join(" ")
      .split(";")
      .join(" ")
      .split(" ")
      .some(x => x == "post" || x == "postbox");
    if (!poBox) {
      this.showPostBox = false;
    } else {
      this.showPostBox = true;
    }
  }

  getAddressFormats(formatId: string) {
    this.showSmallLoader = true;
    this._addNewClientService
      .getAddressFormatsByFormatId(formatId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.filterAddressesUsingAddressFormats(res?.data?.descriptionD365);
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  filterAddressFormats(countryId: string) {
    const filteredRegions = this.countryRegionList.filter(
      x => x.countryRegionD365 == countryId
    );
    if (filteredRegions.length > 0) {
      if (filteredRegions[0].addressFormatD365) {
        this.getAddressFormats(filteredRegions[0].addressFormatD365);
      }
    }
  }

  getStateListData(id: string) {
    this.showSmallLoader = true;
    this._addNewClientService
      .getStateList(id)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.stateList = res?.data;
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  updateValueOnCountrySelection() {
    this.clientForm.patchValue({
      addressInformation: {
        zipCodeD365: "",
        districtNameD365: "",
        cityD365: "",
        countyD365: "",
        stateD365: "",
      },
    });
  }

  onStateSelectionChange(stateid: string) {
    this.clientForm.patchValue({ addressInformation: { cityD365: "" } });
    this.getCityListData(stateid, this.countryRegionSelectedId);
  }

  onCountryRegionSelection(countryid: string) {
    if (countryid) {
      this.clientForm.get(["addressInformation", "zipCodeD365"])?.enable();
      this.clientForm.get(["addressInformation", "districtNameD365"])?.enable();
      this.clientForm.get(["addressInformation", "cityD365"])?.enable();
      this.clientForm.get(["addressInformation", "countyD365"])?.enable();
      this.clientForm.get(["addressInformation", "stateD365"])?.enable();
    } else {
      this.clientForm.get(["addressInformation", "zipCodeD365"])?.disable();
      this.clientForm
        .get(["addressInformation", "districtNameD365"])
        ?.disable();
      this.clientForm.get(["addressInformation", "cityD365"])?.disable();
      this.clientForm.get(["addressInformation", "countyD365"])?.disable();
      this.clientForm.get(["addressInformation", "stateD365"])?.disable();
    }

    const countryregionid = countryid ?? "";
    if (countryregionid == "") {
      if (this.zipList != null) this.zipList.length = 0;
      if (this.districtList != null) this.districtList.length = 0;
      if (this.cityList != null) this.cityList.length = 0;
      if (this.countyList != null) this.countyList.length = 0;
      if (this.stateList != null) this.stateList.length = 0;
      this.addressValidationStatus = true;
      this.updateValueOnCountrySelection();
    } else {
      this.updateValueOnCountrySelection();
      this.filterAddressFormats(countryregionid);
      this.getCountyListData(countryregionid);
      this.getStateListData(countryregionid);
    }
  }

  async getResaleCertificateFile(file: Event): Promise<void> {
    const filIn = file.target as HTMLInputElement;
    if (filIn.files && filIn.files.length > 0) {
      const fileObj = filIn.files[0];
      const filesize = Math.round(fileObj.size / this.fileSizeInKb);
      if (filesize <= this.fileSizeInKb) {
        this.resaleCertificateFileName = fileObj.name;
        const fileExtensionPart = fileObj.name.split(".").pop();
        const fileextension = fileExtensionPart
          ? "." + fileExtensionPart.toLowerCase()
          : "";
        await getBase64(fileObj).then(data => {
          this.createAttachmentFileObject(
            FileName.resale,
            FileType.url,
            data as string
          );
          this.createFileUploadDto(
            data as string,
            FileName.resale,
            fileextension,
            filesize,
            fileObj.type
          );
        });
        this.resaleCertificateValidationMessage = false;
        this.resaleCertificateRemove = true;
        this.resaleCertificateFileSize = false;
      } else {
        this.resaleCertificateFileSize = true;
      }
    }
  }

  async getTaxExemptionFile(file: Event): Promise<void> {
    const filIn = file.target as HTMLInputElement;
    if (filIn.files && filIn.files.length > 0) {
      const fileObj = filIn.files[0];
      const filesize = Math.round(fileObj.size / this.fileSizeInKb);
      if (filesize <= this.fileSizeInKb) {
        this.taxExemptionFileName = fileObj.name;
        const fileExtensionPart = fileObj.name.split(".").pop();
        const fileextension = fileExtensionPart
          ? "." + fileExtensionPart.toLowerCase()
          : "";
        await getBase64(fileObj).then(data => {
          this.createAttachmentFileObject(
            FileName.taxExemption,
            FileType.url,
            data as string
          );
          this.createFileUploadDto(
            data as string,
            FileName.taxExemption,
            fileextension,
            filesize,
            fileObj.type
          );
        });
        this.taxExemptionValidationMessage = false;
        this.taxExemptionRemove = true;
        this.taxExemptionFileSize = false;
      } else {
        this.taxExemptionFileSize = true;
      }
    }
  }

  // Global drag-and-drop handlers
  onResaleCertificateDropped(droppedFiles: DroppedFile[]): void {
    if (droppedFiles.length > 0 && !this.isResaleToggleStatus) {
      const file = droppedFiles[0];
      const mockEvent = {
        target: { files: [file.file] },
      } as any;

      this.getResaleCertificateFile(mockEvent);
    }
  }

  onTaxExemptionDropped(droppedFiles: DroppedFile[]): void {
    if (droppedFiles.length > 0 && !this.isTaxExemptionToggleStatus) {
      const file = droppedFiles[0];
      const mockEvent = {
        target: { files: [file.file] },
      } as any;

      this.getTaxExemptionFile(mockEvent);
    }
  }

  onFilesRejected(rejectedFiles: { file: File; reason: string }[]): void {
    this._globalFileUploadService.handleRejectedFiles(rejectedFiles);
  }

  createAttachmentFileObject(name: string, extension: string, data: string) {
    this.fileAttachment.push({
      typeIdD365: extension,
      notesD365: data,
      restrictionD365: 1,
      descriptionD365: name,
      // createdDate: "",
      // createdBy: "",
      // lastModifiedDate: null,
      // lastModifiedBy: null,
      // isActive: false,
    });
  }

  createFileUploadDto(
    data: string,
    name: string,
    extension: string,
    size: number,
    filemimetype: string
  ) {
    const base64File = data.split(",")[1];
    this.fileObject.push({
      base64: base64File,
      fileName: name,
      fileExtension: extension,
      fileSize: size,
      fileMimeType: filemimetype,
    });
  }

  addDataInClientInfoArray(
    clientContactArray: ClientInformation,
    locator: string,
    title: string,
    purpose: string,
    isPrimary: string,
    type: string
  ) {
    const obj = {
      firstNameD365: clientContactArray.clientFirstNameD365,
      lastNameD365: clientContactArray.clientLastNameD365,
      locatorD365: locator,
      title: title,
      purposeD365: purpose,
      isPrimaryD365: isPrimary,
      typeD365: type,
    };
    return obj;
  }

  addDataInInvoiceInfoArray(
    clientContactArray: InvoiceInformation,
    locator: string,
    title: string,
    purpose: string,
    isPrimary: string,
    type: string
  ) {
    const obj = {
      firstNameD365: clientContactArray.invoiceFirstNameD365,
      lastNameD365: clientContactArray.invoiceLastNameD365,
      locatorD365: locator,
      title: title,
      purposeD365: purpose,
      isPrimaryD365: isPrimary,
      typeD365: type,
    };
    return obj;
  }

  addDataInPayableInfoArray(
    clientContactArray: PayableInformation,
    locator: string,
    title: string,
    purpose: string,
    isPrimary: string,
    type: string
  ) {
    const obj = {
      firstNameD365: clientContactArray.payableFirstNameD365,
      lastNameD365: clientContactArray.payableLastNameD365,
      locatorD365: locator,
      title: title,
      purposeD365: purpose,
      isPrimaryD365: isPrimary,
      typeD365: type,
    };
    return obj;
  }

  async getAttachmentUrlData(attachment: FileUploadDto[]) {
    const rescaleObj = attachment.filter(x => x.fileName == FileName.resale);
    const taxObj = attachment.filter(x => x.fileName == FileName.taxExemption);

    if (rescaleObj.length > 0 && this.isResaleToggleStatus == false) {
      this.resaleFileUrl = await lastValueFrom(
        this._addNewClientService.getRescaleAttachmentUrl(rescaleObj)
      );
    }
    if (taxObj.length > 0 && this.isTaxExemptionToggleStatus == false) {
      this.taxexemptionFileUrl = await lastValueFrom(
        this._addNewClientService.getTaxAttachmentUrl(taxObj)
      );
    }
    this.files = {
      rescaleFile:
        this.resaleFileUrl != undefined ? this.resaleFileUrl.data : "",
      taxFile:
        this.taxexemptionFileUrl != undefined
          ? this.taxexemptionFileUrl.data
          : "",
    };
  }
  private removeAddressFields() {
    if (!this.showZip) {
      this.clientForm.patchValue({
        addressInformation: {
          zipCodeD365: "",
        },
      });
    }
    if (!this.showDistrict) {
      this.clientForm.patchValue({
        addressInformation: {
          districtNameD365: "",
        },
      });
    }
    if (!this.showPostBox) {
      this.clientForm.patchValue({
        addressInformation: {
          postBoxD365: "",
        },
      });
    }
    if (!this.showCity) {
      this.clientForm.patchValue({
        addressInformation: {
          cityD365: "",
        },
      });
    }
    if (!this.showCounty) {
      this.clientForm.patchValue({
        addressInformation: {
          countyD365: "",
        },
      });
    }
    if (!this.showState) {
      this.clientForm.patchValue({
        addressInformation: {
          stateD365: "",
        },
      });
    }
    if (!this.showStreetNumber) {
      this.clientForm.patchValue({
        addressInformation: {
          streetNumberD365: "",
        },
      });
    }
    if (!this.showStreet) {
      this.clientForm.patchValue({
        addressInformation: {
          streetD365: "",
        },
      });
    }
    if (!this.showbuildingComplement) {
      this.clientForm.patchValue({
        addressInformation: {
          buildingComplimentD365: "",
        },
      });
    }
    if (!this.showAppartment) {
      this.clientForm.patchValue({
        addressInformation: {
          apartment_RUD365: "",
        },
      });
    }
  }

  removeSpaceFromContactFields(addVendorDto: VendorDto): void {
    if (addVendorDto.clientInformation.clientPhoneNumberD365 != "") {
      const phone = addVendorDto.clientInformation.clientPhoneNumberD365;
      if (phone.includes("+")) {
        addVendorDto.clientInformation.clientPhoneNumberD365 = phone.replace(
          /[- )(]/g,
          ""
        );
      } else {
        const withoutspacingnumber = phone.replace(/[- )(]/g, "");
        if (withoutspacingnumber.length >= 12) {
          const withoutspace =
            withoutspacingnumber.substring(0, 10) +
            " " +
            withoutspacingnumber.substring(10, withoutspacingnumber.length);
          addVendorDto.clientInformation.clientPhoneNumberD365 = withoutspace;
        } else {
          addVendorDto.clientInformation.clientPhoneNumberD365 =
            withoutspacingnumber;
        }
      }
    }
    if (addVendorDto.invoiceInformation.invoicePhoneNumberD365 != "") {
      const phone = addVendorDto.invoiceInformation.invoicePhoneNumberD365;
      if (phone.includes("+")) {
        addVendorDto.invoiceInformation.invoicePhoneNumberD365 = phone.replace(
          /[- )(]/g,
          ""
        );
      } else {
        const withoutspacingnumber = phone.replace(/[- )(]/g, "");
        if (withoutspacingnumber.length >= 12) {
          const withoutspace =
            withoutspacingnumber.substring(0, 10) +
            " " +
            withoutspacingnumber.substring(10, withoutspacingnumber.length);
          addVendorDto.invoiceInformation.invoicePhoneNumberD365 = withoutspace;
        } else {
          addVendorDto.invoiceInformation.invoicePhoneNumberD365 =
            withoutspacingnumber;
        }
      }
    }
    if (addVendorDto.payableInformation.payablePhoneNumberD365 != "") {
      const phone = addVendorDto.payableInformation.payablePhoneNumberD365;
      if (phone.includes("+")) {
        addVendorDto.payableInformation.payablePhoneNumberD365 = phone.replace(
          /[- )(]/g,
          ""
        );
      } else {
        const withoutspacingnumber = phone.replace(/[- )(]/g, "");
        if (withoutspacingnumber.length >= 12) {
          const withoutspace =
            withoutspacingnumber.substring(0, 10) +
            " " +
            withoutspacingnumber.substring(10, withoutspacingnumber.length);
          addVendorDto.payableInformation.payablePhoneNumberD365 = withoutspace;
        } else {
          addVendorDto.payableInformation.payablePhoneNumberD365 =
            withoutspacingnumber;
        }
      }
    }
  }

  submitButtonlogValidationErrors(group: FormGroup = this.clientForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.submitButtonlogValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = "";
        if (abstractControl && !abstractControl.valid) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey && messages) {
              this.formErrors[key] += messages[errorKey] + " ";
            }
          }
        }
      }
    });
  }

  async addNewClientData() {
    this.submitButtonlogValidationErrors();
    this._loaderService.setLoaderState(true);
    this.removeAddressFields();
    const addClientDto = this.clientForm.getRawValue();
    const programId = addClientDto.basicInformation.programId;

    if (this.uses3PLCheckedYes === false && this.uses3PLCheckedNo === false) {
      this._toastr.error(
        "Error",
        "Uses 3rd Party Warehouse option is required"
      );
      this._loaderService.setLoaderState(false);
      return;
    }

    if (
      this.nadelOwnInvCheckedYes === false &&
      this.nadelOwnInvCheckedNo === false
    ) {
      this._toastr.error("Error", "Nadel Owned Inventory option is required");
      this._loaderService.setLoaderState(false);
      return;
    }

    if (!addClientDto.basicInformation.brandingConsultantD365) {
      addClientDto.basicInformation.brandingConsultantD365 = "";
    }
    if (!addClientDto.basicInformation.brandingAccountCordinator) {
      addClientDto.basicInformation.brandingAccountCordinator = "";
    }

    if (this.bcList != null) {
      const userObj = this.bcList.filter(
        x => x.personnelNumber == this.bcUserDefaultSelectionId
      );
      if (userObj.length > 0) {
        if (userObj[0].projectName != null && userObj[0].projectName != "") {
          addClientDto.basicInformation.brandingConsultantD365 =
            userObj[0].projectName;
          addClientDto.basicInformation.bCPersonnelNumberD365 =
            userObj[0].personnelNumber;
        }
      }
    }

    if (this.parentCompanyPartyNumber) {
      addClientDto.basicInformation.parentCompanyPartyNumberD365 =
        this.parentCompanyPartyNumber;
    }

    if (this.isResaleToggleStatus == false) {
      const resaleobj = this.fileAttachment.filter(
        x => x.descriptionD365 === FileName.resale
      );
      if (resaleobj.length == 0) {
        this._toastr.error("Error", "Please upload resale file");
        this._loaderService.setLoaderState(false);
        return;
      }
    }

    if (this.isTaxExemptionToggleStatus == false) {
      const isTaxobj = this.fileAttachment.filter(
        x => x.descriptionD365 === FileName.taxExemption
      );
      if (isTaxobj.length == 0) {
        this._toastr.error("Error", "Please upload tax exemption file");
        this._loaderService.setLoaderState(false);
        return;
      }
    }

    if (this.customerAccountNumberStatus) {
      this._toastr.error("Error", "Client Account Number Required");
      this._loaderService.setLoaderState(false);
      return;
    }

    if (!this.clientForm.valid) {
      this._loaderService.setLoaderState(false);
      return;
    }

    if (this.nadelOwnInvCheckedYes || this.uses3PLCheckedYes) {
      if (this.programName === "" && programId == 0) {
        this._loaderService.setLoaderState(false);
        this.clientSaveAfterProgramAdd = true;
        this.showAddProgramSideBar();
        return;
      }
    }

    if (this.fileAttachment.length > 0) {
      this.fileAttachment = this.fileAttachment.slice(-2);
      await this.getAttachmentUrlData(this.fileObject);
      this.fileAttachment.map(obj => {
        if (obj.descriptionD365 == FileName.resale) {
          obj.notesD365 = this.files?.rescaleFile;
        } else if (obj.descriptionD365 == FileName.taxExemption) {
          obj.notesD365 = this.files?.taxFile;
        }
      });
      if (this.isResaleToggleStatus == true) {
        const itemToRemoveIndex = this.fileAttachment.findIndex(function (
          item: ClientAttachment
        ) {
          return item.descriptionD365 === FileName.resale;
        });
        if (itemToRemoveIndex !== -1) {
          this.fileAttachment.splice(itemToRemoveIndex, 1);
        }
      }
      if (this.isTaxExemptionToggleStatus == true) {
        const itemToRemoveIndex = this.fileAttachment.findIndex(function (
          item: ClientAttachment
        ) {
          return item.descriptionD365 === FileName.taxExemption;
        });
        if (itemToRemoveIndex !== -1) {
          this.fileAttachment.splice(itemToRemoveIndex, 1);
        }
      }
    }

    this.removeSpaceFromContactFields(addClientDto);
    const clientContactArray = [];
    if (
      addClientDto.clientInformation.clientPhoneNumberD365 != "" ||
      addClientDto.clientInformation.clientEmailAddressD365 != "" ||
      addClientDto.clientInformation.clientFirstNameD365 != ""
    ) {
      clientContactArray.push(
        this.addDataInClientInfoArray(
          addClientDto.clientInformation,
          addClientDto.clientInformation.clientPhoneNumberD365,
          addClientDto.clientInformation.clientTitle,
          ClientPurpose.Business,
          this.isPrimaryOne,
          EnumContactType.Phone
        ),
        this.addDataInClientInfoArray(
          addClientDto.clientInformation,
          addClientDto.clientInformation.clientEmailAddressD365,
          addClientDto.clientInformation.clientTitle,
          ClientPurpose.Business,
          this.isPrimaryOne,
          EnumContactType.Email
        )
      );
    }
    if (
      addClientDto.invoiceInformation.invoicePhoneNumberD365 != "" ||
      addClientDto.invoiceInformation.invoiceEmailAddressD365 != "" ||
      addClientDto.invoiceInformation.invoiceFirstNameD365 != ""
    ) {
      clientContactArray.push(
        this.addDataInInvoiceInfoArray(
          addClientDto.invoiceInformation,
          addClientDto.invoiceInformation.invoicePhoneNumberD365,
          addClientDto.invoiceInformation.invoiceTitle,
          ClientPurpose.Invoice,
          this.isPrimaryZero,
          EnumContactType.Phone
        ),
        this.addDataInInvoiceInfoArray(
          addClientDto.invoiceInformation,
          addClientDto.invoiceInformation.invoiceEmailAddressD365,
          addClientDto.invoiceInformation.invoiceTitle,
          ClientPurpose.Invoice,
          this.isPrimaryZero,
          EnumContactType.Email
        )
      );
    }
    if (
      addClientDto.payableInformation.payablePhoneNumberD365 != "" ||
      addClientDto.payableInformation.payableEmailAddressD365 != "" ||
      addClientDto.payableInformation.payableFirstNameD365 != ""
    ) {
      clientContactArray.push(
        this.addDataInPayableInfoArray(
          addClientDto.payableInformation,
          addClientDto.payableInformation.payablePhoneNumberD365,
          addClientDto.payableInformation.payableTitle,
          ClientPurpose.Payment,
          this.isPrimaryZero,
          EnumContactType.Phone
        ),
        this.addDataInPayableInfoArray(
          addClientDto.payableInformation,
          addClientDto.payableInformation.payableEmailAddressD365,
          addClientDto.payableInformation.payableTitle,
          ClientPurpose.Payment,
          this.isPrimaryZero,
          EnumContactType.Email
        )
      );
    }

    const clientAddressArray = [];
    clientAddressArray.push(addClientDto.addressInformation);

    addClientDto.basicInformation.notes = clientAddressArray[0].notes;
    delete clientAddressArray[0].notes;

    this.clientObj = {
      client: addClientDto.basicInformation,
      clientAddress: clientAddressArray,
      clientContacts: clientContactArray as Contact[],
      clientAttachment: this.fileAttachment,
      clientProgramMap: {
        programId: addClientDto.basicInformation.programId,
      },
    };

    if (
      this.clientObj?.client &&
      addClientDto.basicInformation &&
      addClientDto.addressInformation?.billingLocation
    ) {
      this.clientObj.client.billingLocationD365 =
        addClientDto.addressInformation?.billingLocation;
    }
    if (
      this.clientObj?.client &&
      addClientDto.basicInformation &&
      addClientDto.addressInformation?.billingAttention
    ) {
      this.clientObj.client.billingAttentionD365 =
        addClientDto.addressInformation?.billingAttention;
    }

    if (
      this.getObjectFromVerifyClient != undefined &&
      this.getObjectFromVerifyClient.id != 0
    ) {
      let newClientContactArray = [];
      newClientContactArray = this.addContactConvertingProspect(addClientDto);
      this.addClientObj = {
        clientContacts: newClientContactArray,
      };
      this._prospectDetails
        .createNewContact(this.addClientObj)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: () => {
            let updateClientContactArray = [];
            updateClientContactArray =
              this.updateContactConvertingProspect(addClientDto);
            this.updateClientObj = {
              clientContacts: updateClientContactArray,
            };
            this.updateRecordAgainstSerialNumber(
              this.updateClientObj,
              this.clientObj
            );
          },
        });
    } else {
      this._addNewClientService
        .addClientData(this.clientObj as unknown as ClientDetailDto)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: (res: GenericResponseDto<ClientDetailDto>) => {
            if (res.data != null) {
              if (this.nadelOwnInvCheckedYes || this.uses3PLCheckedYes) {
                this.getProgramEmailContent(
                  programId,
                  res.data?.client?.customerAccountD365 ?? ""
                );
              }

              this.addClientRedirect();
            } else {
              this._toastr.error("Error", res.message || "Error adding client");
            }
          },
          error: () => {
            this._loaderService.setLoaderState(false);
            this._toastr.error("Error", "Error adding client");
          },
        });
    }
  }

  checkvalidation(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.value) {
      if (this.parentCompanyPartyNumber) {
        this.parentCompanyNameValid = true;
      } else {
        this.parentCompanyNameValid = false;
      }
    } else {
      this.parentCompanyPartyNumber = "";

      this.parentCompanyNameValid = false;
    }
  }

  updateRecordAgainstSerialNumber(
    updateObject: CreateProspectDto,
    addClientDto: ClientDto
  ) {
    this._prospectDetails
      .UpdateProspectContactBySerialNumberAndAccountNumber(updateObject)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: () => {
          this.convertProspectIntoClient(addClientDto);
        },
      });
  }
  addClientContactConvertProspect(
    clientContactArray: ClientInformation,
    locator: string,
    title: string,
    purpose: string,
    isPrimary: string,
    type: string
  ) {
    const obj = {
      contactSerialNumber: clientContactArray.clientContactSerialNumber,
      firstNameD365: clientContactArray?.clientFirstNameD365,
      lastNameD365: clientContactArray?.clientLastNameD365,
      locatorD365: locator,
      title: title,
      purposeD365: purpose,
      isPrimaryD365: isPrimary == "0" ? "No" : "Yes",
      typeD365: type,
      accountNumber: this.customerAccount,
    };
    return obj;
  }

  addInvoiceContactConvertProspect(
    clientContactArray: InvoiceInformation,
    locator: string,
    title: string,
    purpose: string,
    isPrimary: string,
    type: string
  ) {
    const obj = {
      contactSerialNumber: clientContactArray.invoiceContactSerialNumber,
      firstNameD365: clientContactArray?.invoiceFirstNameD365,
      lastNameD365: clientContactArray?.invoiceLastNameD365,
      locatorD365: locator,
      title: title,
      purposeD365: purpose,
      isPrimaryD365: isPrimary == "0" ? "No" : "Yes",
      typeD365: type,
      accountNumber: this.customerAccount,
    };
    return obj;
  }

  addPayableContactConvertProspect(
    clientContactArray: PayableInformation,
    locator: string,
    title: string,
    purpose: string,
    isPrimary: string,
    type: string
  ) {
    const obj = {
      contactSerialNumber: clientContactArray.payableContactSerialNumber,
      firstNameD365: clientContactArray?.payableFirstNameD365,
      lastNameD365: clientContactArray?.payableLastNameD365,
      locatorD365: locator,
      title: title,
      purposeD365: purpose,
      isPrimaryD365: isPrimary == "0" ? "No" : "Yes",
      typeD365: type,
      accountNumber: this.customerAccount,
    };
    return obj;
  }

  addContactConvertingProspect(addClientDto: any) {
    const clientContactArray = [];
    if (
      addClientDto.clientInformation.clientContactSerialNumber === 0 &&
      addClientDto.clientInformation.clientPhoneNumberD365 != "" &&
      addClientDto.clientInformation.clientEmailAddressD365 != ""
    ) {
      clientContactArray.push(
        this.addClientContactConvertProspect(
          addClientDto.clientInformation,
          addClientDto.clientInformation.clientPhoneNumberD365,
          addClientDto.clientInformation.clientTitle,
          ClientPurposeType.Business,
          this.isPrimaryOne,
          EnumContactType.Phone
        ),
        this.addClientContactConvertProspect(
          addClientDto.clientInformation,
          addClientDto.clientInformation.clientEmailAddressD365,
          addClientDto.clientInformation.clientTitle,
          ClientPurposeType.Business,
          this.isPrimaryOne,
          EnumContactType.Email
        ),
        this.addClientContactConvertProspect(
          addClientDto.clientInformation,
          "",
          addClientDto.clientInformation.clientTitle,
          ClientPurposeType.Business,
          this.isPrimaryOne,
          EnumContactType.Mobile
        )
      );
    }
    if (
      addClientDto.invoiceInformation.invoiceContactSerialNumber === 0 &&
      addClientDto.invoiceInformation.invoicePhoneNumberD365 != "" &&
      addClientDto.invoiceInformation.invoiceEmailAddressD365 != ""
    ) {
      clientContactArray.push(
        this.addInvoiceContactConvertProspect(
          addClientDto.invoiceInformation,
          addClientDto.invoiceInformation.invoicePhoneNumberD365,
          addClientDto.invoiceInformation.invoiceTitle,
          ClientPurposeType.Invoice,
          this.isPrimaryZero,
          EnumContactType.Phone
        ),
        this.addInvoiceContactConvertProspect(
          addClientDto.invoiceInformation,
          addClientDto.invoiceInformation.invoiceEmailAddressD365,
          addClientDto.invoiceInformation.invoiceTitle,
          ClientPurposeType.Invoice,
          this.isPrimaryZero,
          EnumContactType.Email
        ),
        this.addInvoiceContactConvertProspect(
          addClientDto.invoiceInformation,
          "",
          addClientDto.invoiceInformation.invoiceTitle,
          ClientPurposeType.Invoice,
          this.isPrimaryZero,
          EnumContactType.Mobile
        )
      );
    }
    if (
      addClientDto.payableInformation.payableContactSerialNumber === 0 &&
      addClientDto.payableInformation.payablePhoneNumberD365 != "" &&
      addClientDto.payableInformation.payableEmailAddressD365 != ""
    ) {
      clientContactArray.push(
        this.addPayableContactConvertProspect(
          addClientDto.payableInformation,
          addClientDto.payableInformation.payablePhoneNumberD365,
          addClientDto.payableInformation.payableTitle,
          ClientPurposeType.Payment,
          this.isPrimaryZero,
          EnumContactType.Phone
        ),
        this.addPayableContactConvertProspect(
          addClientDto.payableInformation,
          addClientDto.payableInformation.payableEmailAddressD365,
          addClientDto.payableInformation.payableTitle,
          ClientPurposeType.Payment,
          this.isPrimaryZero,
          EnumContactType.Email
        ),
        this.addPayableContactConvertProspect(
          addClientDto.payableInformation,
          "",
          addClientDto.payableInformation.payableTitle,
          ClientPurposeType.Payment,
          this.isPrimaryZero,
          EnumContactType.Mobile
        )
      );
    }
    return clientContactArray;
  }

  updateClientContactConvertProspect(
    clientContactArray: ClientInformation,
    locator: string,
    title: string,
    purpose: string,
    isPrimary: string,
    type: string
  ) {
    const firstName = clientContactArray?.clientFirstNameD365 ?? "";
    const lastName = clientContactArray?.clientLastNameD365 ?? "";
    const obj = {
      contactSerialNumber: clientContactArray.clientContactSerialNumber,
      firstNameD365: clientContactArray?.clientFirstNameD365 ?? "",
      lastNameD365: clientContactArray?.clientLastNameD365 ?? "",
      locatorD365: locator ?? "",
      title: title,
      purposeD365: purpose,
      isPrimaryD365: isPrimary,
      typeD365: type,
      accountNumber: this.customerAccount,
      descriptionD365: firstName + " " + lastName,
    };
    return obj;
  }

  updateInvoiceContactConvertProspect(
    clientContactArray: InvoiceInformation,
    locator: string,
    title: string,
    purpose: string,
    isPrimary: string,
    type: string
  ) {
    const firstName = clientContactArray?.invoiceFirstNameD365 ?? "";
    const lastName = clientContactArray?.invoiceLastNameD365 ?? "";

    const obj = {
      contactSerialNumber: clientContactArray?.invoiceContactSerialNumber,
      firstNameD365: clientContactArray?.invoiceFirstNameD365 ?? "",
      lastNameD365: clientContactArray?.invoiceLastNameD365 ?? "",
      locatorD365: locator ?? "",
      title: title,
      purposeD365: purpose,
      isPrimaryD365: isPrimary,
      typeD365: type,
      accountNumber: this.customerAccount,
      descriptionD365: firstName + " " + lastName,
    };
    return obj;
  }

  updatePayableContactConvertProspect(
    clientContactArray: PayableInformation,
    locator: string,
    title: string,
    purpose: string,
    isPrimary: string,
    type: string
  ) {
    const firstName = clientContactArray.payableFirstNameD365 ?? "";
    const lastName = clientContactArray.payableLastNameD365 ?? "";

    const obj = {
      contactSerialNumber: clientContactArray.payableContactSerialNumber,
      firstNameD365: clientContactArray.payableFirstNameD365 ?? "",
      lastNameD365: clientContactArray.payableLastNameD365 ?? "",
      locatorD365: locator ?? "",
      title: title,
      purposeD365: purpose,
      isPrimaryD365: isPrimary,
      typeD365: type,
      accountNumber: this.customerAccount,
      descriptionD365: firstName + " " + lastName,
    };
    return obj;
  }

  updateContactConvertingProspect(addClientDto: any) {
    const clientContactArray = [];
    if (
      addClientDto.clientInformation.clientContactSerialNumber !== 0 &&
      addClientDto.clientInformation.clientPhoneNumberD365 != "" &&
      addClientDto.clientInformation.clientEmailAddressD365 != ""
    ) {
      let taxObj = [];
      if (this.prospectObject.clientContacts.length > 0) {
        taxObj = this.prospectObject.clientContacts.filter(
          (x: any) => x.type == ClientPurposeType.Business
        );
      }
      clientContactArray.push(
        this.updateClientContactConvertProspect(
          addClientDto.clientInformation,
          addClientDto.clientInformation.clientPhoneNumberD365,
          addClientDto.clientInformation.clientTitle,
          ClientPurposeType.Business,
          taxObj.length > 0 ? taxObj[0].isPrimaryD365 : "NO",
          EnumContactType.Phone
        ),
        this.updateClientContactConvertProspect(
          addClientDto.clientInformation,
          addClientDto.clientInformation.clientEmailAddressD365,
          addClientDto.clientInformation.clientTitle,
          ClientPurposeType.Business,
          taxObj[0].isPrimaryD365,
          EnumContactType.Email
        ),
        this.updateClientContactConvertProspect(
          addClientDto.clientInformation,
          taxObj.length > 0 ? taxObj[0].contactMobile : "",
          addClientDto.clientInformation.clientTitle,
          ClientPurposeType.Business,
          taxObj.length > 0 ? taxObj[0].isPrimaryD365 : "NO",
          EnumContactType.Mobile
        )
      );
    }
    if (
      addClientDto.invoiceInformation.invoiceContactSerialNumber !== 0 &&
      addClientDto.invoiceInformation.invoicePhoneNumberD365 != "" &&
      addClientDto.invoiceInformation.invoiceEmailAddressD365 != ""
    ) {
      let taxObj = [];
      if (this.prospectObject.clientContacts.length > 0) {
        taxObj = this.prospectObject.clientContacts.filter(
          (x: any) => x.type == ClientPurposeType.Invoice
        );
      }
      clientContactArray.push(
        this.updateInvoiceContactConvertProspect(
          addClientDto.invoiceInformation,
          addClientDto.invoiceInformation.invoicePhoneNumberD365,
          addClientDto.invoiceInformation.invoiceTitle,
          ClientPurposeType.Invoice,
          taxObj.length > 0 ? taxObj[0].isPrimaryD365 : "NO",
          EnumContactType.Phone
        ),
        this.updateInvoiceContactConvertProspect(
          addClientDto.invoiceInformation,
          addClientDto.invoiceInformation.invoiceEmailAddressD365,
          addClientDto.invoiceInformation.invoiceTitle,
          ClientPurposeType.Invoice,
          taxObj.length > 0 ? taxObj[0].isPrimaryD365 : "NO",
          EnumContactType.Email
        ),
        this.updateInvoiceContactConvertProspect(
          addClientDto.invoiceInformation,
          taxObj.length > 0 ? taxObj[0].contactMobile : "",
          addClientDto.invoiceInformation.invoiceTitle,
          ClientPurposeType.Invoice,
          taxObj.length > 0 ? taxObj[0].isPrimaryD365 : "NO",
          EnumContactType.Mobile
        )
      );
    }
    if (
      addClientDto.payableInformation.payableContactSerialNumber !== 0 &&
      addClientDto.payableInformation.payablePhoneNumberD365 != "" &&
      addClientDto.payableInformation.payableEmailAddressD365 != ""
    ) {
      let taxObj = [];
      if (this.prospectObject.clientContacts.length > 0) {
        taxObj = this.prospectObject.clientContacts.filter(
          (x: any) => x.type == ClientPurposeType.Invoice
        );
      }

      clientContactArray.push(
        this.updatePayableContactConvertProspect(
          addClientDto.payableInformation,
          addClientDto.payableInformation.payablePhoneNumberD365,
          addClientDto.payableInformation.payableTitle,
          ClientPurposeType.Payment,
          taxObj.length > 0 ? taxObj[0].isPrimaryD365 : "NO",
          EnumContactType.Phone
        ),
        this.updatePayableContactConvertProspect(
          addClientDto.payableInformation,
          addClientDto.payableInformation.payableEmailAddressD365,
          addClientDto.payableInformation.payableTitle,
          ClientPurposeType.Payment,
          taxObj.length > 0 ? taxObj[0].isPrimaryD365 : "NO",
          EnumContactType.Email
        ),
        this.updatePayableContactConvertProspect(
          addClientDto.payableInformation,
          taxObj.length > 0 ? taxObj[0].contactMobile : "",
          addClientDto.payableInformation.payableTitle,
          ClientPurposeType.Payment,
          taxObj.length > 0 ? taxObj[0].isPrimaryD365 : "NO",
          EnumContactType.Mobile
        )
      );
    }
    return clientContactArray;
  }

  convertProspectIntoClient(obj: ClientDto) {
    this._addNewClientService
      .addConvertProspectIntoClientData(obj as unknown as ClientDetailDto)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data != null) {
            this._toastr.success("Success", "Prospect convert successfully");
            if (this.quoteId) {
              const url = `/proposal/quote-summary/${this.quoteId}`;
              this.route.navigate([url]);
            } else {
              const url = `/clients/active/client-details/${this.customerAccount}`;
              this.route.navigate([url]);
            }
          } else {
            this._toastr.error(
              "Error",
              res.message || "Error converting prospect"
            );
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error(
            "Error",
            res.message || "Error converting prospect"
          );
        },
      });
  }

  prospectObject?: any;
  getProspectByIdData(prospectId: string) {
    this._prospectDetails.getProspectById(prospectId).subscribe({
      next: (res: GenericResponseDto<CreateProspectDto>) => {
        if (res?.data != undefined) {
          this.prospectObject = res.data;
          this.customerAccountNumberStatus = false;
          this.patchFormOfProspect(this.prospectObject);
          this.patchValueInBcAndBacAfterProspectConvert();
        }
        this.showSmallLoader = false;
      },
      error: () => {
        this.showSmallLoader = false;
      },
    });
    this.removeParentCompany();
  }

  removeParentCompany() {
    this.parentCompanyNameValid = true;
  }

  patchValueInBcAndBacAfterProspectConvert() {
    if (this.prospectObject && this.bcList) {
      const userObj = this.bcList?.filter(
        x =>
          x.projectName == this.prospectObject?.client?.brandingConsultantD365
      );
      if (userObj?.length > 0) {
        this.getBacForSalesOrderForProspect(userObj[0].personnelNumber);
        this.bcUserDefaultSelectionId = userObj[0].personnelNumber;
        this.bacUserDefaultSelectionId =
          this.prospectObject?.client?.brandingAccountCordinator;
      }
    }
  }

  patchFormOfProspect(obj: CreateProspectDto): void {
    this.customerAccountNumberStatus = false;
    this.customerAccount = obj.client?.customerAccountD365 ?? "";
    if (obj.client != undefined) {
      this.clientForm.patchValue({
        basicInformation: {
          nameAliasD365: obj.client.nameAliasD365,
          knownAsD365: obj.client.knownAsD365,
          partyTypeD365: obj.client.partyTypeD365,
          source: obj.client.source,
          rsmJNIParentCompanyNameD365: obj.client.rsmJNIParentCompanyNameD365,
          dUNSNoD365: obj.client.dunsNoD365,
          salesCurrencyCodeD365: obj.client.salesCurrencyCodeD365,
          companyUrl: obj.client.companyUrl,
          isRequestCreditCheck: obj.client.isRequestCreditCheck,
          customerPORequired: obj.client.customerPORequired,
          isResale: obj.client.isResale,
          isTaxExemption: obj.client.isTaxExemption,
          notes: obj.client.notes,
          brandingConsultantD365: obj.client.brandingConsultantD365,
          brandingAccountCordinator: obj.client.brandingAccountCordinator,
          customerGroupIdD365: obj.client.industry,
        },
      });
    }
    if (obj.clientAddress != null) {
      this.countryRegionSelectedId =
        obj.clientAddress[0].countryRegionIdD365 ?? "";
      this.onCountryRegionSelection(this.countryRegionSelectedId);
      this.zipSelectionCode = obj.clientAddress[0].zipCodeD365 ?? "";
      ((this.stateSelectedId = obj.clientAddress[0].stateD365 ?? ""),
        obj.clientAddress[0].stateD365,
        this.clientForm.patchValue({
          addressInformation: {
            districtNameD365: obj.clientAddress[0].districtNameD365 ?? "",
            postBoxD365: obj.clientAddress[0].postBoxD365 ?? "",
            cityD365: obj.clientAddress[0].cityD365 ?? "",
            countyD365: obj.clientAddress[0].countyD365 ?? "",
            streetNumberD365: obj.clientAddress[0].streetNumberD365 ?? "",
            addressD365: obj.clientAddress[0].addressD365 ?? "",
            streetD365: obj.clientAddress[0].streetD365 ?? "",
            notes: obj.client?.notes ?? "",
            purposeD365: obj.clientAddress[0].purposeD365 ?? "",
            isPrimaryD365: obj.clientAddress[0].isPrimaryD365 ?? "",
            addressLocationNameD365:
              obj.clientAddress[0].addressLocationNameD365 ?? "",
            countryRegionIdD365: obj.clientAddress[0].countryRegionIdD365 ?? "",
            zipCodeD365: obj.clientAddress[0].zipCodeD365 ?? "",
            stateD365: obj.clientAddress[0].stateD365 ?? "",
          },
        }));
    }
    if (obj.clientContacts && obj.clientContacts.length > 0) {
      const Business = obj.clientContacts?.filter(
        (x: any) => x.type == ClientPurposeType.Business
      );
      if (Business.length > 0) {
        const primaryBusiness = Business.filter(
          (x: any) => x.isPrimaryD365 == "Yes"
        );
        this.patchClientForm(
          primaryBusiness.length === 0 ? Business : primaryBusiness
        );
      }
      const Invoice = obj.clientContacts?.filter(
        (x: any) => x.type == ClientPurposeType.Invoice
      );
      if (Invoice.length > 0) {
        const primaryInvoice = Invoice.filter(
          (x: any) => x.isPrimaryD365 == "Yes"
        );
        this.patchInvoiceForm(
          primaryInvoice.length === 0 ? Invoice : primaryInvoice
        );
      }
      const Payment = obj.clientContacts?.filter(
        (x: any) => x.type == "Payable"
      );
      if (Payment.length > 0) {
        const primaryPayment = Payment.filter(
          (x: any) => x.isPrimaryD365 == "Yes"
        );
        this.patchPayableForm(
          primaryPayment.length === 0 ? Payment : primaryPayment
        );
      }
    }
    if (obj.client?.rsmJNIParentCompanyNameD365) {
      this.getParentCompanyName(obj.client.rsmJNIParentCompanyNameD365);
    }
  }

  getParentCompanyName(clientname: string) {
    this._addNewProspectService
      .getClientByNameAndAccountNumberFilter(clientname)
      .subscribe({
        next: res => {
          if (res.data) {
            if (res.data.length > 0) {
              this.parentCompanyPartyNumber = res.data[0].partyNumber ?? "";
            }
          }
        },
      });
  }

  patchClientForm(obj: any) {
    if (obj[0].contactStatus != "D") {
      const descriptionParts = obj[0].descriptionD365
        ? obj[0].descriptionD365.split(" ")
        : [];
      const firstName = descriptionParts[0] ?? "";
      const lastName = descriptionParts[1] ?? "";

      this.clientForm.patchValue({
        clientInformation: {
          clientContactSerialNumber: obj[0]?.contactSerialnumber ?? 0,
          clientFirstNameD365: firstName,
          clientLastNameD365: lastName,
          clientPhoneNumberD365: obj[0]?.contactPhone ?? "",
          clientEmailAddressD365: obj[0]?.contactEmail ?? "",
          clientTitle: obj[0]?.title ?? "",
        },
      });
    }
  }

  patchPayableForm(obj: any) {
    if (obj[0].contactStatus != "D") {
      this.clientForm.patchValue({
        payableInformation: {
          payableContactSerialNumber: obj[0].contactSerialnumber,
          payableFirstNameD365: obj[0].descriptionD365.split(" ")[0],
          payableLastNameD365: obj[0].descriptionD365.split(" ")[1],
          payablePhoneNumberD365: obj[0].contactPhone,
          payableEmailAddressD365: obj[0].contactEmail,
          payableTitle: obj[0].title,
        },
      });
    }
  }

  patchInvoiceForm(obj: any[]) {
    if (obj[0].contactStatus != "D") {
      this.clientForm.patchValue({
        invoiceInformation: {
          invoiceContactSerialNumber: obj[0].contactSerialnumber,
          invoiceFirstNameD365: obj[0].descriptionD365.split(" ")[0],
          invoiceLastNameD365: obj[0].descriptionD365.split(" ")[1],
          invoicePhoneNumberD365: obj[0].contactPhone,
          invoiceEmailAddressD365: obj[0].contactEmail,
          invoiceTitle: obj[0].title,
        },
      });
    }
  }

  searchClientName() {
    this.searchClient$
      .pipe(
        debounceTime(1000),
        distinctUntilChanged(),
        switchMap((searchitem: string) => {
          if (searchitem) {
            this.showSmallLoader = true;
          }
          const clientname = searchitem;
          return this._addNewProspectService.getClientByNameAndAccountNumberFilter(
            clientname
          );
        })
      )
      .subscribe({
        next: (res: GenericResponseDto<ClientSearchList[]>) => {
          if (res.data != null) {
            this.clientLists = res.data;
          }
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  // openParentCompSearch(dropdown: any) {
  //   dropdown.open();
  // }

  onClientSelection(event: ClientEvent): void {
    const name = event.name;
    this.clientForm.patchValue({
      basicInformation: {
        rsmJNIParentCompanyNameD365: name,
      },
    });
    this.parentCompanyPartyNumber = event.partyNumber;
  }

  // onClientSearchOpenToggle(mydrop: any) {
  //   mydrop.open();
  // }

  parentValidation(event: Event, dropdown: Popover) {
    const target = event.target as HTMLInputElement | null;
    const searchValue = target?.value ?? "";
    if (searchValue) {
      const parentList = this.clientLists.filter(
        x =>
          x.name?.toLowerCase()?.includes(searchValue.toLowerCase()) ||
          x.clientAccount?.toLowerCase()?.includes(searchValue.toLowerCase())
      );
      if (parentList.length > 0) {
        this.parentCompanyPartyNumber = parentList[0].partyNumber || "";
        this.patchValueInParentCompany(parentList[0].name || "");
      }
    }

    dropdown.hide();
  }

  patchValueInParentCompany(parent: string) {
    this.clientForm.patchValue({
      basicInformation: {
        rsmJNIParentCompanyNameD365: parent,
      },
    });
  }

  showAddProgramSideBar() {
    this.addprogram.patchValuesInProgramBcfield(this.bcUserDefaultSelectionId);
    this.displayAddProgram = true;
  }

  getAddProgramBarShowStatus(status: boolean) {
    this.displayAddProgram = status;
  }

  getSmallLoaderStatus(status: boolean) {
    this.showSmallLoader = status;
  }

  getAllProgramDropdownValues() {
    this.result$ = forkJoin({
      getFacilitatorList: this._programService.getFacilitatorList(),
      getThreePLList: this._programService.getThreePLList(),
      getPlatformList: this._programService.getPlatformList(),
    }).pipe(
      map(res => {
        return {
          facilitatorList: res.getFacilitatorList.data,
          threePLList: res.getThreePLList.data,
          platformList: res.getPlatformList.data,
        };
      })
    );

    this.result$.subscribe(
      (res: {
        facilitatorList: DropDownDto[];
        threePLList: DropDownDto[];
        platformList: DropDownDto[];
      }) => {
        this.facilitatorList = res.facilitatorList;
        this.threePLList = res.threePLList;
        this.platformList = res.platformList;
      }
    );
  }

  patchProgramValues(programData: AddProgramDto): void {
    this.programName = programData.name;
    this.programData = programData;
    this.onNadeOwnInvCheck(programData.nadelOwnInv);
    this.onUses3PLInvCheck(programData.uses3PL);
    this.clientForm.patchValue({
      basicInformation: {
        programId: programData.id,
      },
    });
    this.isRadioButtonDisabled = true;

    if (this.clientSaveAfterProgramAdd) {
      this.addNewClientData();
      this.clientSaveAfterProgramAdd = false;
    }
  }

  getMyProfile() {
    this._addNewClientService
      .GetMyProfile()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (res: GenericResponseDto<GetUserDto>) => {
          if (res.status.toLowerCase() == "success") {
            this.userInfo = res.data;
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  getProgramEmailContent(programId: number, customerAccount: string) {
    if (this.userInfo && programId != 0) {
      this._programService
        .GetProgramEmailDetails(programId.toString(), customerAccount)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: (res: GenericResponseDto<GetProgramDetailsEmailDto>) => {
            this._loaderService.setLoaderState(false);
            if (res.data != null) {
              this.sendProgramCreationEmail(res.data);
            } else {
              this._toastr.error(
                "Error",
                res.message || "Error sending program email"
              );
            }
          },
          error: res => {
            this._loaderService.setLoaderState(false);
            this._toastr.error(
              "Error",
              res.message || "Error sending program email"
            );
          },
        });
    }
  }

  sendProgramCreationEmail(details: GetProgramDetailsEmailDto) {
    const toRecipients: MicrosoftGraph.Recipient[] = [];
    details.receiverEmail.forEach((x: string) => {
      if (x !== "") {
        toRecipients.push({
          emailAddress: {
            address: x,
            name: x || undefined,
          },
        });
      }
    });

    const sender: MicrosoftGraph.Recipient = {
      emailAddress: {
        address: this.userInfo.sendEmailAs,
        name: this.userInfo.displayEmailAs,
      },
    };

    let mailMessage: MicrosoftGraph.Message = {};

    mailMessage = {
      subject: details.subject,
      body: {
        contentType: "html",
        content: details.html,
      },
      toRecipients: toRecipients,
      sender: sender,
    };

    const mail = {
      message: mailMessage,
    };
    this._msalApisService.sendMail(mail).subscribe({
      next: () => {
        this.addClientRedirect();
      },
      error: () => {
        this._loaderService.setLoaderState(false);
      },
    });
  }

  getProgram($event: ProgramListDto | ProgramClientListDto) {
    this.programName = $event.name ?? "";
    this.clientForm.patchValue({
      basicInformation: {
        programId: $event.id,
      },
    });
    if ("uses3PL" in $event) {
      this.onUses3PLInvCheck($event.uses3PL);
    }
    if ("nadelOwnInv" in $event) {
      this.onNadeOwnInvCheck($event.nadelOwnInv);
    }
    this.isRadioButtonDisabled = true;
  }

  addClientRedirect() {
    this._loaderService.setLoaderState(false);
    this._toastr.success("Success", "Client added successfully");
    const url = `/clients/client-details/${this.customerAccount}`;
    this.route.navigate([url]);
  }

  onNadeOwnInvCheck($event: boolean) {
    if ($event) {
      this.nadelOwnInvCheckedYes = true;
      this.nadelOwnInvCheckedNo = false;
    } else {
      this.nadelOwnInvCheckedYes = false;
      this.nadelOwnInvCheckedNo = true;
    }
    this.patchValuesInAddProgramBlade();
  }

  onUses3PLInvCheck($event: boolean) {
    if ($event) {
      this.uses3PLCheckedYes = true;
      this.uses3PLCheckedNo = false;
    } else {
      this.uses3PLCheckedYes = false;
      this.uses3PLCheckedNo = true;
    }
    this.patchValuesInAddProgramBlade();
  }

  patchValuesInAddProgramBlade() {
    this.addprogram.patchValuesInNadelOwnedAndThirdPartyfields(
      this.nadelOwnInvCheckedYes,
      this.uses3PLCheckedYes
    );
  }

  navigateToClientListing() {
    this.route.navigate(["clients/active"]);
  }
}
